import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SearchSuggestions {
  manufacturers: string[];
  partTypes: string[];
  jobCategories: string[];
  serviceCategories: string[];
}

export function useSearchSuggestions() {
  return useQuery<SearchSuggestions>({
    queryKey: ['search-suggestions'],
    queryFn: async () => {
      const { data } = await supabase
        .from('v_filter_options')
        .select('asset_type, filter_key, filter_value, listing_count')
        .in('filter_key', ['manufacturer', 'item_type', 'category', 'employment_type'])
        .order('listing_count', { ascending: false });

      const manufacturers = [...new Set(
        data?.filter(d => d.filter_key === 'manufacturer').map(d => d.filter_value) || []
      )].slice(0, 8);

      const partTypes = data?.filter(d => d.asset_type === 'parts' && d.filter_key === 'item_type')
        .map(d => d.filter_value).slice(0, 6) || [];

      const jobCategories = data?.filter(d => d.asset_type === 'jobs' && d.filter_key === 'category')
        .map(d => d.filter_value).slice(0, 6) || [];

      const serviceCategories = data?.filter(d => d.asset_type === 'services' && d.filter_key === 'category')
        .map(d => d.filter_value).slice(0, 6) || [];

      return { manufacturers, partTypes, jobCategories, serviceCategories };
    },
    staleTime: 30 * 60 * 1000,
  });
}
